import PageHeader from "@/components/PageHeader";

const approaches = [
  {
    key: "TCC",
    title: "Terapia Cognitivo-Conductual",
    body: "Identifica y transforma pensamientos, emociones y conductas que sostienen el malestar. Trabajo estructurado, orientado a metas.",
  },
  {
    key: "TDC",
    title: "Terapia Dialéctico-Conductual",
    body: "Regulación emocional, tolerancia al malestar, atención plena y habilidades interpersonales para vidas intensas.",
  },
  {
    key: "SIS",
    title: "Enfoque Sistémico",
    body: "Miramos a la persona dentro de sus vínculos: familia, pareja y contexto. Ideal para dinámicas relacionales complejas.",
  },
  {
    key: "GES",
    title: "Gestalt",
    body: "Trabajo en el aquí y ahora: contacto, integración de partes disociadas y responsabilización afectiva.",
  },
  {
    key: "HUM",
    title: "Humanista",
    body: "Persona en el centro. Aceptación incondicional, empatía y autenticidad como marco de acompañamiento.",
  },
  {
    key: "MND",
    title: "Mindfulness",
    body: "Entrenamiento de atención plena para regular el estrés, la ansiedad y sostener el bienestar cotidiano.",
  },
];

const Enfoques = () => {
  return (
    <div data-testid="enfoques-page">
      <PageHeader
        eyebrow="04 · Enfoques Terapéuticos"
        title="Integración con criterio clínico."
        subtitle="No aplicamos un solo modelo: elegimos, con evidencia y criterio, la combinación que mejor acompaña tu proceso."
      />

      <section className="px-6 md:px-14 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {approaches.map((a, i) => (
            <article
              key={a.key}
              data-testid={`approach-${a.key}`}
              className="card-soft p-8 flex gap-6 rise"
              style={{ animationDelay: `${100 * (i + 1)}ms` }}
            >
              <div
                className="shrink-0 w-16 h-16 rounded-full flex items-center justify-center"
                style={{
                  background: "var(--p-burgundy)",
                  color: "var(--p-gold-soft)",
                  fontFamily: "Cinzel, serif",
                  letterSpacing: "0.08em",
                  fontSize: "0.85rem",
                }}
              >
                {a.key}
              </div>
              <div>
                <h3
                  style={{
                    fontFamily: "Cormorant Garamond, serif",
                    fontSize: "1.5rem",
                    fontWeight: 600,
                    color: "var(--p-black)",
                  }}
                >
                  {a.title}
                </h3>
                <p className="mt-2" style={{ fontFamily: "Cormorant Garamond, serif", color: "var(--p-brown)", lineHeight: 1.6 }}>
                  {a.body}
                </p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="px-6 md:px-14 pb-24">
        <div
          className="rounded-sm p-8 md:p-12"
          style={{ background: "#fbf6ec", border: "1px solid rgba(138,116,101,0.2)" }}
        >
          <p className="eyebrow" style={{ color: "var(--p-burgundy)" }}>Por qué integrar</p>
          <h2
            className="mt-3"
            style={{
              fontFamily: "Cormorant Garamond, serif",
              fontSize: "clamp(1.6rem, 3vw, 2.4rem)",
              fontWeight: 500,
              color: "var(--p-black)",
            }}
          >
            Ningún enfoque es completo por sí solo.
          </h2>
          <p className="mt-3 max-w-3xl" style={{ fontFamily: "Cormorant Garamond, serif", color: "var(--p-brown)", fontSize: "1.1rem" }}>
            La integración ,fundamentada en evidencia, permite abordar cada
            problema con las herramientas más adecuadas, sin encajar tu historia
            en un solo molde teórico.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Enfoques;
